export default __webpack_public_path__ + "static/stock-2-0d331cdc77db544a215da80707446d1a.jpg";